import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControlComponent } from '@shared/component/form-controls/abstract-control/abstract-control.component';
import { CalendarReminderTypeEnum } from 'taxtank-core';

import { MaterialModule } from '@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { ValidationErrorModule } from '@shared/component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-reminder-type-select',
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    TranslatePipe,
    ValidationErrorModule
  ],
  templateUrl: './reminder-type-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reminder-type-select.component.scss'
})
export class ReminderTypeSelectComponent extends AbstractControlComponent<number> {
  @Input() hasEmptyOption = false;
  @Input() inputClass: string;
  @Input() placeholder = 'Select';
  readonly types = CalendarReminderTypeEnum;
}
